import React from 'react';
import useTranslation from '../i18n/useTranslation';
import '../styles/ai-player.css';

const AIThinkingIndicator = ({ aiName }) => {
  const { t } = useTranslation();

  return (
    <div className="ai-thinking-container">
      <div className="ai-thinking">
        <span className="robot-icon">🤖</span>
        <span className="thinking-text">
          {t.ai.thinking.replace('{name}', aiName)}
          <span className="dots">
            <span className="dot">.</span>
            <span className="dot">.</span>
            <span className="dot">.</span>
          </span>
        </span>
      </div>
    </div>
  );
};

export default AIThinkingIndicator;
